import {
  Box,
  List,
  styled,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import React from "react";
import { useLocation } from "react-router-dom";
import variables from "../../sass/variables.module.scss";
import MixedText from "../mixed-color-text";
import { menus } from "./menus";

const drawerWidth = 200;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  backgroundColor: variables.secondaryColor,
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const DrawerMd = ({ handleMenuClick }) => {
  const open = true;

  const location = useLocation();

  return (
    <Drawer variant="permanent" open={open}>
      <DrawerHeader className="text-white menu-header">
        <p onClick={() => handleMenuClick("/")} className="cursor-pointer">
          <MixedText first="Khurshida" second="Jahan" />{" "}
        </p>
      </DrawerHeader>
      <Box className="menu-items">
        <List>
          {menus.map((item) => (
            <ListItem key={item?.name} disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={{
                  color:
                    location.pathname === item.link
                      ? variables.primaryColor
                      : "white",
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 1.5,
                }}
                onClick={() => handleMenuClick(item?.link)}
              >
                <ListItemIcon
                  sx={{
                    color:
                      location.pathname === item.link
                        ? variables.primaryColor
                        : "white",
                    minWidth: 0,
                    mr: open ? 1 : "auto",
                    justifyContent: "center",
                  }}
                >
                  {<item.icon />}
                </ListItemIcon>
                <ListItemText
                  primary={item?.name}
                  sx={{
                    color:
                      location.pathname === item.link
                        ? variables.primaryColor
                        : "white",
                    opacity: open ? 1 : 0,
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
    </Drawer>
  );
};

export default DrawerMd;
